import { Injectable } from '@angular/core';
import { OrderTypeEnum } from '@core/enums';
import { StoreProcessingStrategy } from './interfaces';
import { PickupStoresStrategy, DeliveryStoresStrategy } from './strategies';

@Injectable({ providedIn: 'root' })
export class StoresFactory {
	private readonly strategies = new Map<string, StoreProcessingStrategy>([
		[OrderTypeEnum.Pickup, new PickupStoresStrategy()],
		[OrderTypeEnum.Delivery, new DeliveryStoresStrategy()],
	]);

	getStrategy(orderType: string = OrderTypeEnum.Pickup): StoreProcessingStrategy {
		const strategy = this.strategies.get(orderType);
		if (!strategy) {
			return this.strategies.get(OrderTypeEnum.Pickup)!;
		}
		return strategy;
	}

	getPickupStrategy(): StoreProcessingStrategy {
		return this.strategies.get(OrderTypeEnum.Pickup)!;
	}

	getDeliveryStrategy(): StoreProcessingStrategy {
		return this.strategies.get(OrderTypeEnum.Delivery)!;
	}
}
